import {StyledEngineProvider} from '@mui/material/styles';
import {LicenseInfo} from '@mui/x-license';
import {PostHogErrorBoundary, PostHogProvider} from '@posthog/react';
import ErrorBanner from 'components/ErrorBanner';
import {createRoot} from 'react-dom/client';
import {redactShareTokenFromUrl} from 'services/shareSession';
import App from './App';
import {API_BASE_URL} from './constants';
import './i18n'; // Initialize i18n

LicenseInfo.setLicenseKey(
  'a2337f6f6b4f167526025ec794e66800Tz0xMjk3MDksRT0xODExNzIxNTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MSxBVD1zaW5nbGUsS1Y9Mg==',
);

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <PostHogProvider
    apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
    options={{
      // debug: import.meta.env.MODE === 'development',
      api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
      defaults: '2025-11-30',
      disable_capture_url_hashes: true,
      enable_heatmaps: false,
      capture_heatmaps: false,
      capture_pageview: false,
      capture_pageleave: true,
      autocapture: false,
      capture_exceptions: true,
      __add_tracing_headers: [
        API_BASE_URL.replace('https://', '')
          .replace('http://', '')
          .replace(':8000', '')
          .replace('/api', ''),
      ],
      // Disable PostHog in development mode
      before_send: (event) => {
        if (import.meta.env.VITE_APP_ENVIRONMENT === 'dev') {
          return null;
        }

        // `$current_url` is built from `window.location.href`, fragment included.
        if (event?.properties) {
          for (const key of ['$current_url', '$referrer', '$pageview_url']) {
            const value = event.properties[key];
            if (typeof value === 'string') {
              event.properties[key] = redactShareTokenFromUrl(value);
            }
          }
        }

        return event;
      },
    }}
  >
    <PostHogErrorBoundary fallback={<ErrorBanner />}>
      <StyledEngineProvider injectFirst>
        <App />
      </StyledEngineProvider>
    </PostHogErrorBoundary>
  </PostHogProvider>,
);
